import React, { useState } from "react";
import { AlertCircle } from "lucide-react";
import { showToast } from "../../../../../Helper/Toast";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { hitDeleteAccountProfessionalApi } from "../../../../../Redux/Professional/DeleteAccountProfessionalSlice";
import Permanently from "../../../../../assets/img/Permanently Delete Account.svg";

const DeleteAccount = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isConfirmed, setIsConfirmed] = useState(false);

  const handleDeleteAccount = () => {
    if (isConfirmed) {
      dispatch(hitDeleteAccountProfessionalApi()).then((response) => {
        if (response.payload && response.payload.status === true) {
          showToast("Account deleted successfully", "success");
          localStorage.removeItem("professionalToken");
          localStorage.removeItem("professionalId");
          localStorage.removeItem("professionalData");
          navigate("/professional/login");
          window.location.reload();
        } else {
          showToast("Account deletion failed", "error");
        }
      });
    }
  };

  return (
      <div className="delete-account-container">
        <div className="warning-card">
          <div className="warning-header">
            <img src={Permanently} alt="Permanently" className="warning-icon" />
            <h2 className="warning-title">Permanently Delete Account</h2>
          </div>

          <p className="warning-description">
            Once you delete your account, there is no going back. Please be
            certain. All your project data, payment history, and messages will
            be permanently removed.
          </p>

          <div className="confirmation-section">
            <label className="checkbox-container">
              <input
                type="checkbox"
                className="checkbox-input"
                checked={isConfirmed}
                onChange={(e) => setIsConfirmed(e.target.checked)}
              />
              <span className="checkbox-label">
                I understand that this action cannot be undone
              </span>
            </label>
          </div>

          <button
            className="delete-button"
            onClick={handleDeleteAccount}
            disabled={!isConfirmed}
          >
            Delete My Account
          </button>
        </div>
      </div>
  );
};

export default DeleteAccount;
